import { Component, Output, OnInit, EventEmitter, Input, ViewChild, QueryList, ElementRef, OnChanges } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { GraphComponent } from '../graph/graph.component';
import { UIChart } from 'primeng/chart';
import { HomeService } from '../../services/home.service';

import { Settings } from '../../services/settings';
import { retry } from 'rxjs/operators';
import { Card } from 'primeng/card';
import { DashboardService } from "../../services/dashboard.service";
import { ServiceRequestsService } from "../../services/service-requests.service";

@Component({

	selector: 'card-component',
	templateUrl: './card.component.html',
	styleUrls: ['./card.component.css']
})

export class CardComponent implements OnInit, OnChanges {

	private _selectedChart: any;

	data: any;
	options: any;

	_selectedFiscalYear: any;

	titlePositionOptions = [{ name: 'Left', code: 'left' }, { name: 'Center', code: 'center' }, { name: 'Right', code: 'flex-end' }];
	legendPositionOptions = [{ name: 'Left', code: 'left' }, { name: 'Top', code: 'top' }, { name: 'Right', code: 'right' }, { name: 'Bottom', code: 'bottom' }];
	chartDataOptions = [{ name: 'Show', code: true }, { name: 'Hide', code: false }];
	timeLineOptions = [{ name: 'Monthly', code: 'monthly' }, { name: 'Quarterly', code: 'quarterly' }, { name: 'Yearly', code: 'yearly' }];
	timeFrameOptions = [{ name: 'Current Year', code: 'currentyear' }, { name: 'Last Year', code: 'lastyear' }, { name: 'Two Years', code: 'twoyears' }];

	selectedTitlePosition = this.titlePositionOptions[0];
	selectedLegendPosition = this.legendPositionOptions[2];
	selectedChartData = this.chartDataOptions[0];
	selectedTimeLine = this.timeLineOptions[0];
	selectedTimeFrame = this.timeFrameOptions[0];
	public completedRequestStatuses: any;
	public allRequestStatuses: any;
	public _agencyId: number = 0;

	@ViewChild('chart') graph: GraphComponent;
	@ViewChild('cardContent') cardContent;
	@ViewChild('configure') configure: OverlayPanel;

	@Input() private refreshEvent: EventEmitter<boolean>;

	@Input() set agencyId(value: any) {
		this._agencyId = value;
	}
	get agencyId(): number {
		return this._agencyId;
	}
	@Input() set selectedChart(value: any) {
		this._selectedChart = value;
		//this.loadChartDetails();
	}

	@Input() set selectedFiscalYear(value: any) {
		this._selectedFiscalYear = value;
		//this.loadChartDetails();
	}

	get selectedChart(): any {
		return this._selectedChart;
	}
	constructor(private dashboardService: DashboardService, public serviceRequestsService: ServiceRequestsService) {
		/** set up the request status list for completed requests **/

	}

	ngOnInit() {
		if (this.refreshEvent) {
			this.refreshEvent.subscribe(data => {
				this.doApplyProperties();
			});
		}
	}
	public loadRequestStatuses(): void {
		this.completedRequestStatuses = [];
		this.allRequestStatuses = [];
		this.serviceRequestsService.getAllRequestStatuses().subscribe(
			(result) => {
				this.allRequestStatuses = result;
				for (let rec of result) {
					if ((rec.activeStatus === 'Active') && (rec.recordStatus === 0)) {
						this.completedRequestStatuses.push(rec.shortDescription);
					}
				}
				this.selectChartData();
			},
			(error) => {
				/** nothing **/
			});
	}
	ngOnChanges() {
		this.loadChartDetails();
	}

	loadChartDetails() {
		if (this.selectedChart == null || this.selectedChart === undefined || this.selectedChart.dataSource === '') {
			return;
		}

		if ((this.selectedChart.dataSource === 'dsCompleted') && (this.completedRequestStatuses === undefined)) {
			this.loadRequestStatuses();
		}
		else {
			this.selectChartData();
		}
	}
	public selectChartData(): void {
		/* load chart data */
		this.dashboardService.getChartData(this.selectedChart.dataSource, this._agencyId).subscribe(
			(data) => {
				this.setData(data);
				this.setOptions();
			},
			(error) => {
				Settings.getInstance().handleError(error);
			}
		);
	}
	public setData(data: any): void {
		const switchParam = this.selectedChart.dataSource.split('/');
		let values = [];

		switch (switchParam[0]) {

			case 'dsAging':
				let totalAging = 0;
				let agingRecords = [];

				this.graph.data = []

				values.push({ label: 'current', sum: 0 });
				values.push({ label: 'over5', sum: 0 });
				values.push({ label: 'over10', sum: 0 });
				values.push({ label: 'over30', sum: 0 });

				for (let rec of data) {
					values.find(s => s.label === rec.label).sum = rec.sum;
					totalAging += Number(rec.sum);
				}
				for (let i = 0; i < 4; i++) {
					agingRecords.push(Number(values[i].sum));
				}

				this.graph.setBarOptionValues(this.selectedLegendPosition.code, this.selectedChartData.code, 'Total:' +
					' ' + totalAging);

				this.data = [];
				this.data.labels = ['Current', 'Over 5', 'Over 10', 'Over 30'];
				this.data.datasets = [{ label: '# Requests', backgroundColor: '#7ac7ff', data: agingRecords }];
				break;
			case 'openServiceCounts':

				let serviceRecords = [];
				this.data = [];
				let labels = [];
				let total = 0;
				let other = 0;
				for (let i = 0; i < data.length; i++) {
					if (i < 5) {
						labels.push(data[i].description);
						serviceRecords.push(Number(data[i].cntr));
						total += Number(data[i].cntr);
					}
					else {
						other += Number(data[i].cntr);
						total += Number(data[i].cntr);
					}
				}
				/** if there are more than six categories **/
				if (data.length > 5) {
					labels.push('Other');
					serviceRecords.push(Number(other));
				}

				this.graph.setPieOptionValues(this.selectedLegendPosition.code, this.selectedChartData.code,
					'Total: ' + total);
				this.data.labels = labels
				this.data.datasets = [{ label: 'Services', backgroundColor: this.getColorSpectrum(), data: serviceRecords }];
				break;
			case 'dsCompleted':
				let completedTotal = 0;
				let dataSets = [];

				this.graph.data = []


				for (let item of this.completedRequestStatuses) {
					dataSets.push({ type: 'bar', label: item, backgroundColor: this.getStackedBarBackgroundColor(item), data: [] });
				}

					for (let rec of data) {
					completedTotal += Number(rec.sum);

					const ds = dataSets.find(s => s.label === rec.finalstatus);
					if (!ds) continue;

					ds.data = ds.data || [];

					if (rec.label === 'current') {
						ds.data.push(rec.sum);
						continue;
					}
					if (rec.label === 'prior_month') {
						ds.data.push(rec.sum);
						continue;
					}
					if (rec.label === '3_months') {
						ds.data.push(rec.sum);
						continue;
					}
				}
				this.graph.setBarOptionValues(this.selectedLegendPosition.code, this.selectedChartData.code, "Total:" +
					+ completedTotal);
				this.data = [];
				this.data.labels = ['Current', 'Prior Month', 'Past 3 Mo.'];
				this.data.datasets = dataSets;

				break;
			default:
				break;
		}
	}
	public getStackedBarBackgroundColor(item: string): string {
		try {
			let id = this.allRequestStatuses.find(s => s.shortDescription === item)?.id;

			const primaryColors = {
				2: '#B4FFEB', 3: '#06A24A', 4: '#e81212', 5: '#6a666e',
				7: '#ffde59', 8: '#1986d3', 9: '#DE9D09', 10: '#1986d3'
			};

			if (id && primaryColors[id]) return primaryColors[id];

			const secondaryColors = [
				'#A83279', '#D99E82', '#82D9A5', '#8276D9', '#D9C382',
				'#C482D9', '#82D9C2', '#D982A8', '#82A8D9', '#D98282',
				'#82D982', '#A8D982', '#82D9D9', '#C2A882', '#A882C2',
				'#D9A882', '#D982C2', '#C2D982', '#D9C2A8', '#C2D9A8'
			];

			return secondaryColors[this.allRequestStatuses.findIndex(s => s.shortDescription === item) % secondaryColors.length];
		} catch { }

		return '#7ac7ff';
	}

	public setOptions(): void {

		/* just get the webmethod name (not parameters) */
		const switchParam = this.selectedChart.dataSource.split('/');

	}
	public getColorSpectrum(): any {

		return [
			"rgb(6,162,74)",
			"rgb(66,165,245)",
			"rgb(255,222,89)",
			"rgb(232,82,18)",
			"rgb(119,129,239)",
			"rgb(106,102,110)",
			"rgba(255,167,38,0.98)"];
	}
	public onResizeWindow($event) {
		if (this.graph === undefined) {
			return;
		}

		// this.graph.resizeChild(this.cardContent.nativeElement.offsetWidth,
		// this.cardContent.nativeElement.offsetHeight);
	}
	public onLaunchConfigureSettings(event): boolean {
		this.configure.toggle(event);
		return false;
	}
	public onLegendPositionChange(event) {
		if (event === undefined)
			return;

		this.selectedLegendPosition = this.legendPositionOptions.find(({ code }) => code === event.value);
	}
	public onDataLabelPlacementChange(event) {
		if (event === undefined)
			return;

		this.selectedChartData = this.chartDataOptions.find(({ code }) => code === event.value);
	}
	public onApplyHandler(event) {
		/* apply the changes to the chart */
		this.doApplyProperties();
	}
	public doApplyProperties() {

		switch (this.selectedChart.type) {
			case 'gantt':
				break;
		}
		this.setOptions();
		this.configure.hide();
	}
	public onResetHandler(event) {
		this.selectedLegendPosition = this.legendPositionOptions.find(({ code }) => code === 'right');
		this.selectedChartData = this.chartDataOptions.find(({ code }) => code === true);
		this.setOptions();
		this.configure.hide();
	}
	public onCancelHandler(event) {
		this.configure.hide();
	}
	public onCaptureClickHandler(event) {
		this.graph.captureChart();
	}
	public onTimelineChange(event) {
		this.selectedTimeLine.name = event.value;
	}
	public onTimeFrameChange(event) {
		this.selectedTimeFrame = this.timeFrameOptions.find(s => s.code === event.value);
	}
}
